import { Heading } from '../common/heading';
import Posts from '../components/posts';

const InfinityScroll = () => {
	return (
		<div>
			<Heading text="Infinity Scroll" />
			<Posts />
		</div>
	);
};

export default InfinityScroll;
